import { connect } from 'react-redux'
import { Component, Currency } from "macguffin"
import { Stage } from 'mc_pixi-fiber'

import { Loader } from "pixi.js"
const { resources } = Loader.shared

import ArrayHelper from "utils/ArrayHelper"
import WinningSymbol from "./WinningSymbol"
import Scatter from "./Scatter"
import GameMode from "game/modes"
import BackgroundImage from "utils/BackgroundImage"

const SPINES = {
    H1: "winning-symbols-high",
    H2: "winning-symbols-high",
    H3: "winning-symbols-high",
    M4: "winning-symbols-medium",
    M5: "winning-symbols-medium",
    M6: "winning-symbols-medium",
    L7: "winning-symbols-low",
    L8: "winning-symbols-low",
    L9: "winning-symbols-low",
    L10: "winning-symbols-low",
    WR: "winning-symbols-wild"
}

const FONT_SCALE = 0.15

function getSymbols(currentWinData) {
    if (!currentWinData) {
        return []
    }

    //keep a hash of winning symbols so we don't add duplicates
    const uniqueSymbols = {}

    currentWinData.forEach((winData) => {
        const { symbol, winningSymbols } = winData

        winningSymbols.forEach((winningSymbol) => {
            const { x, y } = winningSymbol
            const key = `${x}-${y}`

            if (!uniqueSymbols[key]) {
                uniqueSymbols[key] = {
                    x: x - 1,
                    y: y - 1,
                    symbol,
                    spine: SPINES[symbol]
                }
            }
        })
    })

    return Object.values(uniqueSymbols)
}

function getScatters(scatters, symbols, reelIndex) {
    const reel = symbols[reelIndex]

    reel.forEach((symbol, symbolIndex) => {
        if (symbol === "SC") {
            const key = `${reelIndex}-${symbolIndex}`
            scatters.push({
                key,
                x: reelIndex,
                y: symbolIndex
            })
        }
    })

    return scatters
}

@connect(state => ({
    currentWinData: state.game.currentWinData,
    currentSpinData: state.game.currentSpinData,
    currentWinIteration: state.game.currentWinIteration,
    currentGameMode: state.game.currentGameMode,
    respinSummary: state.game.respinSummary,
    globalPaused: state.base.paused,
    reelStoppedIndex: state.game.reelStoppedIndex
}),{})

export default class WinSymbols extends Component {

    constructor(props) {
        super(props)

        const prepare = [
            resources["badge"].texture.baseTexture,
            resources["reel-atlas"].spritesheet.baseTexture,
            resources["winning-symbols-high_atlas_page_H.png"].texture.baseTexture,
            resources["winning-symbols-medium_atlas_page_M.png"].texture.baseTexture,
            resources["winning-symbols-low_atlas_page_L.png"].texture.baseTexture,
            resources["winning-symbols-wild_atlas_page_wild.png"].texture.baseTexture,
            resources["winning-symbols-glow_atlas_page_H_glow.png"].texture.baseTexture,
            resources["winning-symbols-star_atlas_page_H_star.png"].texture.baseTexture
        ]

        this.state = {
            prepare
        }
    }

    componentWillReceiveProps(nextProps) {
        const currentProps = this.props

        if (nextProps.reelStoppedIndex === -1 && nextProps.reelStoppedIndex !== currentProps.reelStoppedIndex) {
            this.setState({ currentWinData: undefined, symbols: undefined, scatters: undefined })
            return
        }

        if (nextProps.currentWinData !== currentProps.currentWinData) {
            const { currentWinData } = nextProps
            const symbols = getSymbols(currentWinData)
            this.setState({ currentWinData: undefined, symbols })

        } else if (nextProps.currentWinIteration !== currentProps.currentWinIteration) {
            const { currentWinData, currentWinIteration } = nextProps
            const currentLineData = currentWinData[currentWinIteration]
            const symbols = getSymbols([ currentLineData ])

            this.setState({ currentWinData: currentLineData, symbols })
        }

        if (nextProps.reelStoppedIndex > -1 && nextProps.reelStoppedIndex !== currentProps.reelStoppedIndex) {
            const { currentSpinData:{symbols}, reelStoppedIndex } = nextProps
            const { scatters = [] } = this.state

            const newScatters = getScatters(scatters, symbols, reelStoppedIndex)
            this.setState({ scatters: newScatters })
        }
    }

    renderWinAmount(currentWin, symbolWidth, symbolHeight) {
        const { winningSymbols } = currentWin
        const winValue = Currency.format(currentWin.win)

        const lastSymbol = ArrayHelper(winningSymbols).last()
        const { x, y } = lastSymbol

        const left = (x - 1) * symbolWidth + (symbolWidth * 0.5)
        const top = (y - 1) * symbolHeight + (symbolHeight * 0.5)

        const style = {
            position: "absolute",
            width: `${symbolWidth}px`,
            height: `${symbolHeight}px`,
            top: `${top + (symbolHeight * 0.33)}px`,
            left: `${left}px`,
            fontSize: `${symbolHeight * FONT_SCALE}px`,
            backgroundPosition: "center"
        }

        return <BackgroundImage className="winValue" assetName="winlineBackground" style={style}>
            <div> { winValue } </div>
        </BackgroundImage>
    }

    render() {
        const { props, state } = this
        const { currentGameMode, currentSpinData, currentWinIteration, left, top, width, height, visibility, resolution, globalPaused, respinSummary } = props
        const { currentWinData, symbols = [], prepare, scatters = [] } = state || {}

        const symbolWidth = width / 5
        const symbolHeight = height / 3

        const showWilds = (currentGameMode === GameMode.FREESPIN) || respinSummary

        const style = {
            top: `${top}px`,
            left: `${left}px`,
            visibility
        }

        return <div className="winningSymbolsContainer" style={style}>
                <Stage
                    key = "winningSymbolsCanvas"
                    name = "winningSymbolsCanvas"
                    style = {{ width, height }}
                    {...{
                      resolution: resolution,
                      width: width,
                      height: height,
                      paused: globalPaused || !symbols.length,
                      options: {
                            prepare,
                            transparent: true,
                            backgroundColor: 0x000000,
                            antialias: true,
                          }
                    }}
                >
                {
                    symbols && symbols.map((symbol, index) => {
                        const key = `${currentWinIteration}-${index}`

                        if (currentSpinData.symbols[symbol.x][symbol.y] !== "WR") {
                            return <WinningSymbol
                                key = { key }
                                width = { symbolWidth }
                                height = { symbolHeight }
                                paused = { globalPaused }
                                {...symbol}
                            />
                        } else if (showWilds) {
                            symbol.symbol = "wild"
                            symbol.spine = SPINES.WR

                            return <WinningSymbol
                                key = { key }
                                width = { symbolWidth }
                                height = { symbolHeight }
                                paused = { globalPaused }
                                {...symbol}
                            />
                        }
                    })
                }
                {
                    scatters && scatters.map((scatter) => {
                        const { key, x, y } = scatter
                        return (<Scatter {...scatter} width={symbolWidth} height={symbolHeight} />)
                    })
                }
                </Stage>
                {
                    currentWinData && this.renderWinAmount(currentWinData, symbolWidth, symbolHeight)
                }
        </div>
    }
}
